import React, { useState, useRef, useEffect } from "react";

const CustomDropdown = ({ options, selectedOption, onSelect, icon, label , className="" }) => {
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = (e) => {
        e.stopPropagation();
        setIsDropdownVisible(!isDropdownVisible);
    };

    const handleSelect = (e, option) => {
        e.stopPropagation();
        onSelect(option);
        setIsDropdownVisible(false);
    };

    const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setIsDropdownVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <div className="dropdownBox">
            <a href="javascript:void(0)" onClick={toggleDropdown}>
                {icon && <i className={icon + ' symbol'}/>}
                <span>{selectedOption || label}</span> <i className="fa-solid fa-chevron-down right"></i>
            </a>
            {isDropdownVisible && (
                <ul className="dropDownLoc" ref={dropdownRef}>
                    {options && options.length > 0 &&
                        options.map((option, index) => (
                            <li key={index} className={className}>
                                <a href="javascript:void(0)" onClick={(e) => handleSelect(e, option)}>
                                    <span>{option}</span>
                                </a>
                            </li>
                        ))
                    }
                </ul>
            )}
        </div>
    );
};

export default CustomDropdown;
